import memoize from 'memoize-one';
import { objectMultiKeySorter } from '../../utils/sorting';
export const getTenants = memoize((state) => {
    const tenantStore = state.get('tenantStore');
    const tenants = tenantStore.get('tenants');
    const keys = ['displayName', 'defaultDomain'];
    const sorter = objectMultiKeySorter(keys);
    return tenants.sort(sorter);
});
